/* eslint-disable react/prop-types */
function BoxTwoIcon({ className = "", width = "64px", height = "64px", fill = "#000000" }) {
  return (
    <svg
      className={className}
      fill={fill}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 73.86 81.5"
    >
    <g id="b">
      <g id="c">
        <polygon points="68.82 74.6 68.8 58.98 67.04 58.98 67.06 73.99 36.93 79.74 36.87 79.73 6.86 74.02 6.86 59 5.1 59 5.1 74.62 5.93 75.63 36.73 81.5 37.15 81.5 67.99 75.6 68.82 74.6"/>
        <g>
          <path d="M68.75,42.43l-.79-.69-30.87-5.89h-.39l-30.8,5.89-.79,.69L0,58.25l.95,1.31H27.35l.94-.62,8.64-20,8.64,20,.94,.62h26.39l.95-1.31-5.11-15.82Zm-41.88,15.37H2l4.66-14.42,28.82-5.5-8.6,19.91Zm20.12,0l-8.6-19.91,28.82,5.49,4.65,14.42h-24.87Z"/>
          <rect x="36.08" y="37.12" width="1.76" height="43.19"/>
        </g>
      </g>
      <path d="M17.55,8.14c.04,.3,.19,.56,.43,.74l7.99,6.12c.24,.18,.53,.26,.83,.22,.3-.04,.56-.19,.74-.43,.18-.24,.26-.53,.22-.83s-.19-.56-.43-.74h0l-7.99-6.12c-.2-.15-.43-.23-.68-.23-.05,0-.1,0-.15,.01-.3,.04-.56,.19-.74,.43-.18,.24-.26,.53-.22,.83Z"/>
      <path d="M48.72,13.97c-.04,.3,.04,.59,.22,.83,.18,.24,.44,.39,.74,.43,.29,.04,.59-.04,.83-.22l7.99-6.12c.24-.18,.39-.44,.43-.74s-.04-.59-.22-.83c-.18-.24-.44-.39-.74-.43-.05,0-.1-.01-.15-.01-.24,0-.48,.08-.68,.23l-7.99,6.12c-.24,.18-.39,.44-.43,.74Z"/>
      <path d="M38.24,0c-.62,0-1.12,.5-1.12,1.12V11.08c0,.62,.5,1.12,1.12,1.12s1.12-.5,1.12-1.12V1.12c0-.62-.5-1.12-1.12-1.12Z"/>
    </g>
  </svg>
  );
}

export default BoxTwoIcon;
